import { render, staticRenderFns } from "./EducationalPeriodInfo.vue?vue&type=template&id=0b6ae20e&"
import script from "./EducationalPeriodInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports